import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/es6.regexp.to-string";
import _toConsumableArray from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var timer;
import border from '@/components/border/borderType'; // import calendar from '@/components/Echart/calendar'

import calendarPie from '@/components/env-bigData/calendarPie';
import calendar from '@/components/env-bigData/calendar';
import monthSelect from '@/components/date/bmonthSelect'; // 空气质量指数表盘图

import instrument from '@/components/env-bigData/instrument'; // 空气质量指数进度图

import barType from '@/components/env-bigData/barType'; // 空气质量指数图

import schedule from '@/components/env-bigData/schedule'; // 空气质量天数表盘图

import plate from '@/components/env-bigData/plate'; // 空气质量天数双表盘图

import doublePlate from '@/components/env-bigData/doublePlate';
import analysis from '@/components/env-bigData/analysis';
import warn from '@/components/border/warn';
import { queryScreenWarn, queryDateSkylist, queryStandardTreeList, querySkyCurveAnalysis, querSkyReport, standardSkyMonth, querySkyPie, skystandardMonth, queryWastDateList } from '@/api/api';
export default {
  data: function data() {
    return {
      showRadio: true,
      firstPollution: {},
      showCalendar: true,
      waterWarnList: [],
      showDetail: false,
      showIt: false,
      defaultValue: 1,
      showAnalysis: false,
      showPie: true,
      showToast: false,
      stand: [],
      toastText: '',
      analysisType: 11,
      title: [],
      colors: ['#ccc'],
      defaultValues: 0,
      radioIndex: '',
      radioStatu: true
    };
  },
  components: {
    border: border,
    calendar: calendar,
    monthSelect: monthSelect,
    warn: warn,
    instrument: instrument,
    schedule: schedule,
    analysis: analysis,
    plate: plate,
    doublePlate: doublePlate,
    calendarPie: calendarPie,
    barType: barType
  },
  props: {
    selectId: {
      default: '0',
      type: String
    },
    selectType: {
      default: '0',
      type: String
    }
  },
  watch: {
    selectId: function selectId(val) {
      var _this = this;

      this.showRadio = false;
      this.$nextTick(function () {
        _this.showRadio = true;
        _this.defaultValues = 1;
        _this.analysisType = 11;
        clearInterval(timer);

        _this.$nextTick(function () {
          _this.getStandard(val);

          _this.getAir(val);

          _this.getPolutionData(val);

          _this.getWarn(_this.defaultValues, val, _this.selectType);

          _this.getSkyList(val);
        });
      });
    }
  },
  beforeDestroy: function beforeDestroy() {
    //清除定时器
    clearInterval(timer);
  },
  created: function created() {},
  mounted: function mounted() {// setInterval(this.scroll, 1000)
  },
  methods: {
    // 站点警报的tab切换
    changetadios: function changetadios(e) {
      this.defaultValues = e;
      if (e == 0) this.radioIndex = '';else this.radioIndex = e;
      this.getWarn(this.radioIndex, this.selectId, this.selectType); // this.getWarn(this.radioIndex,this.selectType)
    },
    // 获取空气质量指数仪表盘数据
    getSkyList: function getSkyList(id) {
      var _this2 = this;

      querySkyPie({
        scope: 1,
        scopeId: id
      }).then(function (res) {
        if (res.success && res.result) {
          _this2.$refs.plate.initBarChart(res.result['excellent']);

          _this2.$refs.doublePlate.initBarChart(res.result['PM25'], res.result['pollution']);
        } else {
          _this2.$refs.plate.initBarChart({
            someNum: 0,
            nowNum: 0
          });

          _this2.$refs.doublePlate.initBarChart({
            someNum: 0,
            nowNum: 0
          }, {
            someNum: 0,
            nowNum: 0
          });
        }
      });
    },
    // 获取AQI数据
    getPolutionData: function getPolutionData(id, start) {
      var _this3 = this;

      if (id) this.siteId = id;
      if (!start) start = this.getDay(0);
      querySkyCurveAnalysis({
        scopeId: this.siteId,
        type: 1,
        stime: start,
        etime: this.getDay(0),
        dataType: this.analysisType // id: this.siteId,
        // type: this.analysisType,
        // stime: start,
        // etime: this.getDay(0),
        // factorGroup: 'airTeams',

      }).then(function (res) {
        if (res.success) {
          if (res.result.records.length > 0) {
            var obj = {};
            var popArr = [];
            var arr = [];
            var time = [];
            var labelData = [];
            var seriesData = {};
            res.result.query.factors.forEach(function (ele) {
              if (ele.alias == 'AQI') return;
              labelData.push(ele.title);
              res.result.records.forEach(function (element) {
                if (element.factor[ele.code]) {
                  obj.name = element.dataTime;
                  obj.value = element.factor[ele.code].value != null ? element.factor[ele.code].value.toFixed(2) : '';
                  arr.push(obj);
                  obj = {};
                }
              });
              seriesData.data = arr;
              seriesData.title = ele.title;
              popArr.push(seriesData);
              seriesData = {};
              arr = [];
            });
            res.result.records.forEach(function (data) {
              time.push(data.dataTime);
            }); // this.pollutionData = popArr
            // this.time = time
            // this.labelData = labelData

            _this3.showAnalysis = false;

            _this3.$nextTick(function () {
              _this3.showAnalysis = true;

              _this3.$nextTick(function () {
                _this3.$refs.pollution.initBarChart(popArr, time, labelData);
              });
            });
          } else {
            var _labelData = [];
            res.result.query.factors.forEach(function (item, index) {
              _labelData.push(item.title);
            });
            _this3.showAnalysis = false;

            _this3.$nextTick(function () {
              _this3.showAnalysis = true;

              _this3.$nextTick(function () {
                _this3.$refs.pollution.initBarChart([], [], _labelData);
              });
            });
          }
        }
      });
    },
    // 点击蓝天日历对应日期的弹框
    ontoGet: function ontoGet(value, year) {
      var _this4 = this;

      console.log(value, year);
      this.resetSetItem('siteId', this.selectId);
      this.resetSetLocalItem('treeSt', '22'); // window.localStorage.setItem('treeSt','21')

      this.resetSetItem('siteType', '22');
      setTimeout(function () {
        _this4.$router.push({
          path: '/online/cn2061',
          query: {
            year: year
          }
        });
      }, 500); // if (value) this.toastText = value
      // else this.toastText = '暂无数据'
      // this.showToast = true
      // setTimeout(() => {
      // 	this.showToast = false
      // }, 2000)
    },
    // 获取国标数据
    getStandard: function getStandard(id) {
      var _this5 = this;

      queryStandardTreeList().then(function (res) {
        if (res.success) {
          // res.result[0].children[0].children.forEach((item, index) => {
          //   item.data.title = item.data.title.replace('类', '')
          //   item.data.show = true
          //   return item
          // })
          var arr = [];
          var stand = [];
          _this5.colors = ['#ccc'];
          res.result.forEach(function (item, index) {
            if (item.label == '国家标准') {
              if (item.children != null) {
                item.children.forEach(function (item1, index1) {
                  if (item1.key == 'K1_2') {
                    arr = item1.children;
                    stand = JSON.parse(JSON.stringify(item1.children));
                    return;
                  }
                });
              }
            }
          });
          var colors = [];
          var title = [];
          arr.forEach(function (item, index) {
            // item.data.title = item.data.title.replace('类', '')
            colors.push(item.data.color);
            title.push(item.data.title); // return item
          });
          _this5.title = title; // // stand.forEach((item, index) => {
          // // 	item.data.title = item.data.title.replace('类', '')
          // // 	return item
          // // })

          _this5.colors = [].concat(colors, _toConsumableArray(_this5.colors));
          _this5.standardList = arr;
          _this5.stand = stand;

          _this5.getReport(id);
        }
      });
    },
    // 点击aqi  tab的切换
    changeRadio: function changeRadio(e) {
      var time;

      switch (e.target.value) {
        case 1:
          this.analysisType = 11;
          this.getPolutionData('', this.getDay(0));
          break;

        case 2:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(7));
          break;

        case 3:
          this.analysisType = 12;
          this.getPolutionData('', this.getDay(30));
          break;
      }
    },
    // 获取日期
    getDay: function getDay(day) {
      var today = new Date();
      var targetday_milliseconds = today.getTime() - 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码

      var tYear = today.getFullYear();
      var tMonth = today.getMonth();
      var tDate = today.getDate();
      var hour = today.getHours();
      var minute = today.getMinutes();
      var second = today.getSeconds();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + '-' + tMonth + '-' + tDate; // return tYear + '-' + tMonth + '-' + tDate+' '+hour+':'+minute+':'+second
    },
    doHandleMonth: function doHandleMonth(month) {
      var m = month;

      if (month.toString().length == 1) {
        m = '0' + month;
      }

      return m;
    },
    // 点击蓝天日历产看饼图的饼图图标
    ontoSelect: function ontoSelect() {
      this.showDetail = true;
      this.showIt = true;
    },
    scroll: function scroll() {
      var _this6 = this;

      setTimeout(function () {
        if (_this6.waterWarnList.length > 6) {
          _this6.waterWarnList.push(_this6.waterWarnList[0]); // 将数组的第一个元素添加到数组的


          _this6.waterWarnList.shift(); //删除数组的第一个元素

        }
      }, 500);
    },
    // 普通日历日期选择器
    monthChange: function monthChange(value) {
      this.quantum = value;

      if (this.siteId) {
        this.getReport(this.siteId);
      }
    },
    getDaysInOneMonth: function getDaysInOneMonth(year, month) {
      month = parseInt(month, 10);
      var d = new Date(year, month, 0);
      return d.getDate();
    },
    // 获取蓝天日历数据
    getReport: function getReport(id) {
      var _this7 = this;

      querSkyReport({
        scopeId: id,
        scope: 1,
        st: 22,
        type: 3,
        quantum: this.quantum
      }).then(function (res) {
        if (res.success) {
          var a = [];

          var num = _this7.getDaysInOneMonth(_this7.quantum.split('-')[0], _this7.quantum.split('-')[1]);

          res.result.records.forEach(function (item, index) {
            if (index < num) {
              if (item.attrs.currentStandard) {
                for (var i = 0; i < _this7.standardList.length; i++) {
                  if (_this7.standardList[i].data.title == item.attrs.currentStandard.title) {
                    a.push(i);
                    break;
                  }
                }
              } else {
                a.push(_this7.standardList.length);
              }
            }
          });

          _this7.$nextTick(function () {
            _this7.$refs.calendar.initBarChart(_this7.quantum.split('-')[0], _this7.quantum.split('-')[1], a, _this7.colors, _this7.title);
          });
        }
      });
    },
    // 饼图日历日期选择器
    changemMonth: function changemMonth(value) {
      var _this8 = this;

      this.showPie = false;
      this.$nextTick(function () {
        _this8.showPie = true;

        if (_this8.siteId) {
          _this8.getStandmonth(_this8.siteId, value);
        }
      });
    },
    // 获取单个月标准次数饼图
    getStandmonth: function getStandmonth(id, quantum) {
      var _this9 = this;

      skystandardMonth({
        scopeId: id,
        quantum: quantum
      }).then(function (res) {
        if (res.success) {
          var label = [];
          var a = [];
          var color = [];
          var arr = [];
          var data = [];
          res.result.standard.forEach(function (item, index) {
            label.push(item.title);
          });
          var monthArr = Object.keys(res.result.monthStandard);
          monthArr.forEach(function (item, index) {
            if (!(JSON.stringify(res.result.monthStandard[item]) == '{}')) {
              var arrs = [];
              var obj = {};

              for (var i = 0; i < res.result.standard.length; i++) {
                obj.name = res.result.standard[i].title;
                obj.color = res.result.standard[i].color;

                if (res.result.monthStandard[item][res.result.standard[i].title]) {
                  obj.value = res.result.monthStandard[item][res.result.standard[i].title].num;
                  color.push(res.result.standard[i].color);
                } else {
                  obj.value = 0;
                  color.push('');
                }

                data.push(obj);
                obj = {};
              }

              arr.push(data);
              data = [];
              color = [];
            } else {
              var _obj = {};

              for (var _i = 0; _i < res.result.standard.length; _i++) {
                color.push('');
                _obj.name = res.result.standard[_i].title;
                _obj.color = res.result.standard[_i].color;
                _obj.value = 0;
                data.push(_obj);
                _obj = {};
              }

              arr.push(data);
              data = [];
            }
          });

          _this9.$refs.pie.initBarChart(quantum, label, arr);
        }
      });
    },
    //获取预警内容
    getWarn: function getWarn(category, siteId, st) {
      var _this10 = this;

      var params = {
        // current: 1,
        // size: 20,
        category: category,
        scopeId: siteId,
        scope: 1,
        warnStatus: 1
      }; // 污水站点

      queryScreenWarn(params).then(function (res) {
        if (res.success && res.result.length > 0) {
          res.result.forEach(function (item, index) {
            switch (item.category) {
              case '1':
                item.category_dictText = '数据报警';
                break;

              case '2':
                item.category_dictText = '设备报警';
                break;

              case '4':
                item.category_dictText = '离线预警';
                break;
            }
          });
          _this10.waterWarnList = res.result;
        } else {
          _this10.waterWarnList = [];
        }
      });
    },
    // 获取空气质量实时数据
    getAir: function getAir(id) {
      var _this11 = this;

      if (id) this.siteId = id;
      queryDateSkylist({
        scope: 1,
        scopeId: id,
        st: 22,
        type: 1
      }).then(function (res) {
        if (res.success) {
          // this.$refs.instrument.initBarChart(res.result.records[0].dataCodeMap[res.result.records[0].currentStandard.factors[0].code].value,res.result.records[0].currentStandard.title,res.result.records[0].currentStandard.color)
          if (res.result && res.result.records.length > 0) {
            if (res.result.records[0].attrs.pollutions.length > 0) {
              _this11.$refs.instrument.initBarChart(res.result.records[0].attrs.pollutions[0].aqi, res.result.records[0].attrs.currentStandard.title, res.result.records[0].attrs.currentStandard.color);

              _this11.firstPollution = res.result.records[0].attrs.pollutions[0];
            } else {
              _this11.firstPollution = {};

              _this11.$refs.instrument.initBarChart(0, '无', '#fff');
            }

            var obj = {};
            var arr = [];
            var title = [];
            res.result.query.factors.forEach(function (item, index) {
              // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
              if (res.result.records[0].factor[item.code] && res.result.records[0].factor[item.code].value != null) {
                arr.push(res.result.records[0].factor[item.code].value);
                title.push(item.title);
              }
            });

            if (arr.length > 6) {
              _this11.$refs.bartype.initBarChart(arr.slice(0, 6), title.slice(0, 6), 100);

              clearInterval(timer);
              timer = setInterval(function () {
                arr.push(arr[0]); // 将数组的第一个元素添加到数组的

                arr.shift();
                title.push(title[0]); // 将数组的第一个元素添加到数组的

                title.shift();

                _this11.$refs.bartype.initBarChart(arr.slice(0, 6), title.slice(0, 6), 100);
              }, 2000);
            } else {
              _this11.$refs.bartype.initBarChart(arr, title, 100);
            }
          } else {
            if (res.result.query.factors.length > 0) {
              var _obj2 = {};
              var _arr = [];
              var _title = [];
              res.result.query.factors.forEach(function (item, index) {
                // if (item.title == '空气质量分指数' || item.title == '环境空气质量指数') return
                _arr.push(0);

                _title.push(item.title);
              });

              if (res.result.query.factors.length > 6) {
                _this11.$refs.bartype.initBarChart(_arr.slice(0, 6), _title.slice(0, 6), 100);

                clearInterval(timer);
                timer = setInterval(function () {
                  _arr.push(_arr[0]); // 将数组的第一个元素添加到数组的


                  _arr.shift();

                  _title.push(_title[0]); // 将数组的第一个元素添加到数组的


                  _title.shift();

                  _this11.$refs.bartype.initBarChart(_arr.slice(0, 6), _title.slice(0, 6), 100);
                }, 2000);
              } else {
                _this11.$refs.bartype.initBarChart(_arr, _title, 100);
              }
            } else {
              _this11.$refs.bartype.initBarChart([], [], 100);
            }

            _this11.$refs.instrument.initBarChart(0, '无', '#fff');
          } // this.$refs.schedule.initBarChart()

        }
      });
    }
  }
};